import { render, staticRenderFns } from "./balances.vue?vue&type=template&id=4a2fa71e&scoped=true&"
import script from "./balances.vue?vue&type=script&lang=js&"
export * from "./balances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2fa71e",
  null
  
)

export default component.exports